import * as React from 'react';
import { getValue, Row } from '../Row';
import { selectActiveOption, selectActiveService } from '../../../../selectors/publishTerms';
import { useSelector } from 'react-redux';
import { Discount } from '../Discount';

export const ServiceContainer = () => {
  const activeService = useSelector(selectActiveService);
  const activeOption = useSelector(selectActiveOption);

  if (!activeService || !activeOption || !activeOption.price) {
    return null;
  }

  const { name } = activeService;
  const { marketingPrice, price, days } = activeOption;

  const priceValue = getValue({ price: marketingPrice, days });

  const discount = marketingPrice - price;

  const discountFixed = Math.round(discount * 100) / 100;

  return (
    <>
      <Row name={name} value={priceValue} />
      {!!discount && <Discount discount={discountFixed} days={days} />}
    </>
  );
};
